export default __webpack_public_path__ + "static/athena-7c31852e82475802c616957a72a5a397.webp";